/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { CellsResponseData } from "./CellsResponseData";
export const CellsResponse = core.serialization.object({
    data: CellsResponseData,
});
